import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Modal, ToggleSwitch } from "@toddle-edu/ds-web";
import { AttachmentList } from "Attachment/index";
import {
  createAIConversationAttachments,
  deleteAIConversationAttachment,
} from "../../modules/GPTPlaygroundModule";
import { connect } from "react-redux";
import { ATTACHMENT_OMIT_ATTRIBUTES } from "store/static";

const AttachmentsModal = props => {
  const {
    setIsAttachmentsListOpen,
    isPublicView,
    aiConversationId,
    setIsLoading,
    createAIConversationAttachments,
    deleteAIConversationAttachment,
    conversationAttachments = [],
  } = props;

  const [attachments, setAttachments] = useState(conversationAttachments);
  const [saveInKnowledgeBase, setSaveInKnowledgeBase] = useState(false);

  useEffect(() => {
    const isSavedInKnowledgeBase = _.some(conversationAttachments, attachment =>
      _.get(attachment, "metadata.savedInKnowledgeBase", false)
    );
    if (isSavedInKnowledgeBase) {
      setSaveInKnowledgeBase(true);
    }
  }, []);

  const updateAttachments = value => {
    const latestAttachments = _.get(value, "attachments", []);
    setAttachments(attachments =>
      _.uniqBy([...attachments, ...latestAttachments], "id")
    );
  };

  const onAttachmentDoneClick = async () => {
    const input = _.compact(
      _.filter(attachments, attachment =>
        _.startsWith(_.get(attachment, "id"), "NEW_")
      )
    );

    if (!_.isEmpty(input)) {
      setIsLoading(true);
      await createAIConversationAttachments({
        input: _.map(input, attachmentObj => ({
          ..._.omit(attachmentObj, ["id", ...ATTACHMENT_OMIT_ATTRIBUTES]),
          parentId: aiConversationId,
          parentType: "AI_CONVERSATION",
          saveInKnowledgeBase,
        })),
        aiConversationId,
      });
      setIsLoading(false);
    }
    setIsAttachmentsListOpen(false);
  };

  const onDeletedAttachment = async attachment => {
    const attachmentId = _.get(attachment, "attachmentId");
    if (!_.isEmpty(attachmentId)) {
      setIsLoading(true);

      await deleteAIConversationAttachment({
        input: { attachmentId },
        aiConversationId,
        deleteFromKnowledgeBase: _.get(
          attachment,
          "metadata.savedInKnowledgeBase",
          false
        ),
      });
      setAttachments(
        _.filter(
          attachments,
          attachment => _.get(attachment, "id") !== attachmentId
        )
      );
      setIsLoading(false);
    }
  };

  const onSaveInKnowledgeBaseChange = () => {
    setSaveInKnowledgeBase(!saveInKnowledgeBase);
  };

  return (
    <Modal
      width="475px"
      height="max-content"
      onClose={() => setIsAttachmentsListOpen(false)}
      zIndex={1000}
    >
      <Modal.Header
        title="Attachment(s) for extra context"
        subtitle={
          isPublicView
            ? ""
            : "You can add docx, pdf, xlsx, ppt(x), csv, txt | Links | Youtube Videos"
        }
      />
      <Modal.Body>
        <AttachmentList
          parentId={aiConversationId}
          parentType={"AI_CONVERSATION"}
          isShowIconsInBar={true}
          showV2Icons={true}
          cardType={"design-media-card"}
          mode={isPublicView ? "view" : "edit"}
          label={isPublicView ? "" : "Add your attachment(s)"}
          accept={[
            // docx
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            // pdf
            "application/pdf",
            // txt
            "text/plain",
            // csv
            "text/csv",
            // xlsx
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            // ppt
            "application/vnd.ms-powerpoint",
            // pptx
            "application/vnd.openxmlformats-officedocument.presentationml.presentation",
          ]}
          value={attachments}
          name={"attachments"}
          multiselect={true}
          updateInputField={updateAttachments}
          onDeleteAttachmentCallback={onDeletedAttachment}
          dropDownOptions={[
            { key: "upload_device", label: "upload_device" },
            { key: "add_link", label: "add_link" },
          ]}
          showDeleteButtonForNewUploads={!isPublicView}
          showDeleteForSelfInViewMode={!isPublicView}
          showRenameAttachmentOption={false}
          showLocalAttachmentsInViewMode={false}
        />
      </Modal.Body>
      {!isPublicView ? (
        <Modal.Footer
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <b>Save in knowledge base</b>{" "}
            <ToggleSwitch
              dsVersion="2.0"
              disabled={_.size(conversationAttachments) > 0}
              checked={saveInKnowledgeBase}
              onChange={onSaveInKnowledgeBaseChange}
            />
          </div>
          <Button onClick={onAttachmentDoneClick}>Done</Button>
        </Modal.Footer>
      ) : null}
    </Modal>
  );
};

const mapActionCreators = {
  createAIConversationAttachments,
  deleteAIConversationAttachment,
};

export default connect(null, mapActionCreators)(AttachmentsModal);
